import { makeObservable, observable, action } from 'mobx'

class Person {
    constructor(
        id,
        type,
        locality,
        displayName,
        email,
        phoneType,
        phoneNumber,
        countMultiQuotes,
        countPolicies
    ) {
        this.id = id
        this.type = type
        this.locality = locality
        this.displayName = displayName
        this.value = displayName
        this.email = email
        this.phoneType = phoneType
        this.phone = phoneNumber
        this.phoneNumber = phoneNumber
        this.countMultiQuotes = countMultiQuotes
        this.countPolicies = countPolicies
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }
}

export default Person
